export default __webpack_public_path__ + "static/media/image.2661a762.png";